module.exports = "/lucky-balls/img/drum/drum_loop_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_007.png
// module id = 1022
// module chunks = 0